<template>
  <div class="container">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="-margin-md">重要なお知らせ</HeadingOne>

    <ListGroup v-if="noticeList.length > 0" class="-link -visited">
      <ListItem
        v-for="(notice, index) in noticeList"
        :key="index"
        class="-link"
        :href="notice.url"
      >
        <span class="date -db">{{ notice.display_date }}</span>
        {{ notice.title }}
      </ListItem>
    </ListGroup>

    <BtngroupSingle v-if="readMoreFlag" class="-margin-lg">
      <BtnMain class="-normal" @click.prevent="showMore"> もっと見る </BtnMain>
    </BtngroupSingle>
  </div>
  <!-- container -->
</template>

<script>
import { getNoticeList } from "@/utils/CmsHelper";
import HeadingOne from "@/components/heading/HeadingOne";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import { setMeta } from "@/utils/Meta";
import { goToErrorPage } from "@/utils/Other";

export default {
  name: "Nw003",
  components: {
    BtnMain,
    BtngroupSingle,
    ListItem,
    ListGroup,
    HeadingOne,
    BreadcrumbGroup,
  },
  setup() {
    setMeta({
      title: "重要なお知らせ",
      description:
        "au PAY スマートローンの重要なお知らせの一覧ページになります。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,お知らせ,ニュース,トピックス,重要なお知らせ,緊急のお知らせ",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "重要なお知らせ",
          active: true,
        },
      ],
      isDisabled: false,
      readMoreFlag: false,
      noticeList: [],
    };
  },
  mounted() {
    this.getNotice("1");
  },
  methods: {
    getNotice(first_view_flag = "1") {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        getNoticeList(first_view_flag)
          .then((res) => {
            this.noticeList = this.noticeList.concat(res.notice || []);
            this.readMoreFlag = res.read_more_flag;
          })
          .catch((error) => {
            goToErrorPage(error);
          })
          .finally(() => {
            this.isDisabled = false;
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
    showMore() {
      this.getNotice("0");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
.heading-icon {
  text-align: left !important;
  justify-content: left !important;
}
</style>
